"use client";

import Breadcrumbs from "@/components/breadCrumbAndButton/BreadCrumbAndButton";
import CommonBanner from "@/components/commonBanner/CommonBanner";
import Sidebar, { SideBarTopCard } from "@/components/sideBar/SideBar";
import "../about-us/style.css";
import "./style.css";
export default function PrivacyPolicyClient() {
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Home", href: "/" },
          { label: "Privacy and Cookies Policy" },
        ]}
      />

      {/* ===== HERO BANNER SECTION (Same as About Us) ===== */}
      <div className="post-head container">
        <div className="post-head-wrapper">
          <picture>
            <source
              type="image/webp"
              sizes="(max-width: 1680px) 95vw, (min-width: 1681px) 1600px"
              srcSet="
                https://cdn.coinccinos.com/content/images/size/w3000/format/webp/2024/03/cookies-policy.webp 3000w,
                https://cdn.coinccinos.com/content/images/size/w2400/format/webp/2024/03/cookies-policy.webp 2400w,
                https://cdn.coinccinos.com/content/images/size/w2000/format/webp/2024/03/cookies-policy.webp 2000w,
                https://cdn.coinccinos.com/content/images/size/w1600/format/webp/2024/03/cookies-policy.webp 1600w,
                https://cdn.coinccinos.com/content/images/size/w1000/format/webp/2024/03/cookies-policy.webp 1000w,
                https://cdn.coinccinos.com/content/images/size/w800/format/webp/2024/03/cookies-policy.webp 800w,
                https://cdn.coinccinos.com/content/images/size/w500/format/webp/2024/03/cookies-policy.webp 500w
              "
            />
            <img
              className="post-feature-image"
              src="https://cdn.coinccinos.com/content/images/size/w3000/2024/03/cookies-policy.webp"
              alt="Privacy & Cookie Policy | coinccino"
            />
          </picture>

          <CommonBanner
            authorSlug="riccardocuratolo"
            authorImageSrcSetWebp="https://cdn.coinccinos.com/content/images/size/w200/format/webp/2024/12/Riccardo-Curatolo.webp 200w, https://cdn.coinccinos.com/content/images/size/w100/format/webp/2024/12/Riccardo-Curatolo.webp 100w"
            authorImageSrcSet="https://cdn.coinccinos.com/content/images/size/w200/2024/12/Riccardo-Curatolo.webp 200w, https://cdn.coinccinos.com/content/images/size/w100/2024/12/Riccardo-Curatolo.webp 100w"
            authorImage="https://cdn.coinccinos.com/content/images/size/w200/2024/12/Riccardo-Curatolo.webp"
            authorName="Riccardo Curatolo"
            dateISO="2022-12-13"
            dateLabel="Dec 13, 2022"
            readTime="1 min read"
            title="Privacy and Cookies Policy"
            excerpt="Website Nature and Content Disclaimer"
            facebookUrl="https://en.coinccinos.com/privacy/"
            twitterUrl="https://en.coinccinos.com/privacy/"
          />
        </div>
      </div>

      {/* ===== BODY SECTION (Same Layout as About Us) ===== */}
      <div className="container post-main-wrapper with-sidebar">
        <div className="row gap-2">
          {/* MAIN CONTENT */}
          <div className="col-lg-8 col-md-7 post-page-main">
            <div className="post-content with-sidebar">
              <h2 id="privacy-policy-of-coinccino">
                Privacy Policy of coinccino
              </h2>

              {/* <h3>Privacy Policy</h3> */}

              <figure className="kg-card kg-bookmark-card">
                <a
                  className="kg-bookmark-container"
                  href="https://app.termly.io/policy-viewer/policy.html?policyUUID=30401b6e-223d-409d-89b3-490f723d0fa6"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="kg-bookmark-content">
                    <div className="kg-bookmark-title">
                      Termly Policy Viewer
                    </div>
                  </div>
                </a>
              </figure>

              <h3>Cookies Policy</h3>

              <figure className="kg-card kg-bookmark-card">
                <a
                  className="kg-bookmark-container"
                  href="https://app.termly.io/policy-viewer/policy.html?policyUUID=fc694e64-50c3-422c-86a8-746796610078"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="kg-bookmark-content">
                    <div className="kg-bookmark-title">
                      Termly Policy Viewer
                    </div>
                  </div>
                </a>
              </figure>

              <p>
                In addition to any opt-out functionality provided by any of the
                services listed in this document, Users can read more about how
                to turn off interest-based advertisements in the Cookie Policy.
              </p>
              <p>
                This document contains information about the technologies that
                enable this Website to achieve the purposes described herein.
                These technologies allow the Owner to collect and save
                information (for example by using Cookies) or to use resources
                (for example by running a script) on the User's device when the
                User interacts with this Website.
              </p>
            </div>
          </div>

          {/* SIDEBAR */}
          <div className="col-lg-6 col-md-5 pt-5">
            <SideBarTopCard />
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  );
}
